<template>
    <div v-loading="loading">
        <h2>Tumor Purity And Ploidy Analysis on Box Plots</h2>
        <div class="search-box" style="border: 3px solid #696969; border-radius: 5px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); ">
            <el-row>
                <el-col span="12"><h3 style="margin-top: 5px; margin-bottom: 0;">condition:</h3></el-col>
                <el-col span="12" align="middle" >
                    <el-link icon="el-icon-question" type="primary" href = "/reia/help#3.3.2.6" style='color:blue; margin-top: 5px; float: right; font-size: medium' target="_blank">HELP</el-link>
                </el-col>
            </el-row>
            <el-row>
                <el-col align="middle" >
                    <el-link icon="el-icon-info" type="primary" href = "/reia/statistics" style='color:#409EFF; font-size: large' target="_blank">tumor abbreviations</el-link>
                </el-col>
                <el-col>
                    <div style="text-align: center">
                        <el-transfer style="text-align: left; display: inline-block" :titles="['Cancer', 'Selected']"
                                     filterable filter-placeholder="search cancer" v-model="cancers" :data="cancerList"></el-transfer>
                    </div>
                </el-col>
                <el-col>
                    <div style="text-align: center;">
                        <el-row></el-row>
                        <el-row>
                            <el-col :span="6" :offset="6">
                                <label style="display: block;">Editing Color</label>
                                <el-color-picker v-model="editingColor" :predefine="predefineColors"></el-color-picker>
                            </el-col>
                            <el-col :span="6">
                                <label style="display: block;">Nonediting Color</label>
                                <el-color-picker v-model="nonEditingColor" :predefine="predefineColors">
                                </el-color-picker>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col style="text-align: center;">
                    <br>
                    <el-button type="primary" @click="tumorPlot()">Plot</el-button>
                </el-col>
            </el-row>
        </div>
        <div :style="{'display': isShow}">
            <h3>Result:</h3>
            <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
        </div>
    </div>
</template>
<script>
    import { CANCER_LIST } from "@/assets/datas/cancerList";
    import axios from "axios";
    export default {
        name: "tumor",
        data() {
            return {
                cancerList: CANCER_LIST,
                cancers: [],
                editingColor: '#e2f0d9',
                nonEditingColor: '#a1a3a3',
                isShow: 'none',
                pdfUrl: '',
                loading: false,
            };
        },
        methods: {
            tumorPlot() {
                if (this.cancers.length == 0) {
                    this.$message('Please select at least one cancer type.');
                } else if(this.cancers.length > 20){
                    this.$confirm('Due to the limitation on the computing performance of our web server, please do not select more than twenty cancers.', {type: 'warning'})
                } else {
                    var that = this;
                    var positions = this.$store.state.position;
                    this.loading = true;
                    var editingColor = this.editingColor;
                    var nonEditingColor = this.nonEditingColor;
                    var cancers = this.cancers.join();
                    axios({
                        method: "post",
                        url: "/analysis/tumor",
                        data: {
                            positions: positions,
                            cancers: cancers,
                            editingColor: editingColor,
                            nonEditingColor: nonEditingColor,
                        },
                    }).then(function (response) {
                        that.loading = false;
                        console.log(response.data.data);
                        that.pdfUrl = process.env.VUE_APP_BASE_PDF_URL + response.data.data;
                        that.isShow = "block";
                        // console.log(response);
                    }).catch(function (error) {
                        that.$confirm(`There is a problem with this function, please contact the administrator`, {
                            type: 'error'})
                        console.log(error);
                        that.loading = false;
                    });
                }

            },
        },

    }
</script>